import { connect } from 'react-redux';

import ProjectEditPage from 'pages/project-edit-page';
import { finishUpdatingExistingProject } from 'store/actions/project-edit-actions';
import { selectedProjectLoaded } from 'store/actions/selected-project-actions';
import { checkIfFeatureFlagEnabled } from 'store/actions/selected-statement-actions';

const mapStateToProps = ({ data }) => {
  const {
    currentUser: { data: currentUserData },
  } = data;

  return {
    currentUser: currentUserData,
    stateData: data,
  };
};

const mapDispatchToProps = {
  finishUpdatingExistingProject,
  checkIfFeatureFlagEnabled,
  selectedProjectLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectEditPage);
